import React from "react";
import { motion } from "framer-motion";
import TechnologyStack from "./Technologies1";

const HomeTechnologies = () => {
  const technologies = [
    { name: "React", img: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
    { name: "Node.js", img: "https://miro.medium.com/v2/resize:fit:800/1*COvz0L3FUapYYbsQHHZ90g.png" },
    { name: "Tailwind CSS", img: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
    { name: "Python", img: "https://quantumzeitgeist.com/wp-content/uploads/pythoned.png" },
    { name: "JavaScript", img: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
    { name: "AWS", img: "https://miro.medium.com/v2/resize:fit:1200/1*tFl-8wQUENETYLjX5mYWuA.png" },
  ];

  return (
    <div className="w-full font-sans overflow-x-hidden bg-white">

      {/* HERO SECTION */}
      <section className="relative w-full text-center bg-black px-6 py-32 sm:py-40 md:py-48">
        <motion.h2
          className="text-4xl md:text-6xl font-extrabold text-white mb-4"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Technology <span className="text-[#df2313]">We Use</span>
        </motion.h2>

        <motion.p
          className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Discover the cutting-edge tools and frameworks that power our innovative digital solutions.
        </motion.p>

        {/* Center Scroll Arrow */}
        <button
          onClick={() => {
            const section = document.getElementById("technologies-cards-section");
            if (section) section.scrollIntoView({ behavior: "smooth" });
          }}
          className="
    absolute
    bottom-6 sm:bottom-10

    left-[44%] -translate-x-[47%]   /* MOBILE ONLY: adjust this */
    sm:left-1/2 sm:-translate-x-1/2 /* DESKTOP: stays perfectly centered */

    animate-bounce bg-[#df2313]
    w-12 h-12 sm:w-14 sm:h-14
    rounded-full flex items-center justify-center shadow-lg
    hover:scale-110 transition-transform
  "
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-7 w-7 sm:h-8 sm:w-8 text-white'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
            strokeWidth={3}
          >
            <path strokeLinecap='round' strokeLinejoin='round' d='M19 9l-7 7-7-7' />
          </svg>
        </button>

      </section>

      {/* TECHNOLOGY CARDS SECTION */}
      <section id="technologies-cards-section" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {technologies.map((tech, idx) => (
            <motion.div
              key={idx}
              className="bg-black/90 p-8 rounded-2xl shadow-lg border border-gray-800 flex flex-col items-center
              cursor-pointer hover:shadow-xl transition-shadow"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
              whileHover={{ scale: 1.05, boxShadow: "0 15px 40px rgba(223,35,19,0.45)" }}
            >
              <img
                src={tech.img}
                alt={tech.name}
                className="w-20 h-20 sm:w-24 sm:h-24 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-white">{tech.name}</h3>
            </motion.div>
          ))}
        </div>
      </section>

      {/* TECHNOLOGY STACK BELOW */}
      <TechnologyStack />
    </div>
  );
};

export default HomeTechnologies;